export class HisInformationItem {
  constructor(public name: string, public value: string) {
  }
}
